// extracted by mini-css-extract-plugin
export default {"rateNotesBtn":"NotesDetails_rateNotesBtn__K7yri"};